export default class MagnificPopups {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            $(document).magnificPopup({
                delegate: '.has-lightbox a',
                type: 'image',
                closeOnContentClick: true,
            });
        })
    }
}


